import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Projects = () => {
  const projects = [
    {
      id: 'devops-automation-platform',
      icon: '🔗',
      title: 'Smart Dependency Management Platform',
      tags: ['Automation', 'DevOps', 'Security'],
      description: 'An automation platform that streamlines dependency and security management for development teams, enhancing efficiency and reducing manual workload across the software development lifecycle.'
    },
    {
      id: 'healthcare-compliance-platform',
      icon: '🏥',
      title: 'Healthcare Compliance Platform',
      tags: ['Healthcare', 'Compliance', 'React'],
      description: 'A comprehensive healthcare solution designed to optimize dialysis workflows, compliance monitoring, and clinical technician support, improving patient care and operational efficiency.'
    },
    /* BIOTRACK - commented out, content needs revision
    {
      id: 'specimen-tracking-platform',
      icon: '🔬',
      title: 'Specimen Tracking Platform',
      tags: ['Healthcare', 'Laboratory', 'Compliance'],
      description: 'A laboratory workflow system designed to track biological samples throughout the laboratory process, improving specimen traceability and operational efficiency.'
    },
    */
    {
      id: 'enterprise-warehousing-solution',
      icon: '🚀',
      title: 'Enterprise Warehousing Solution',
      tags: ['Enterprise', 'Cloud', 'Scalability'],
      description: 'Enterprise technology solution focused on scalability and future-ready architecture for business transformation, enabling organizations to adapt and grow.'
    },
    {
      icon: '💳',
      title: 'Banking API Integration',
      tags: ['FinTech', 'Spring Boot', 'APIs'],
      description: 'Developed and integrated payment solutions and middleware for bulk payment systems at a leading commercial bank, including bulk payment integrations and compliance solutions for seamless transactions.'
    },
    {
      icon: '📱',
      title: 'Mobile Solutions Suite',
      tags: ['Flutter', 'Cross-platform', 'Mobile'],
      description: 'Built cross-platform mobile applications for inventory management, blood camp management, and delivery monitoring using Flutter and Dart, serving diverse business needs.'
    },
    {
      icon: '🎓',
      title: 'Student Project Mentorship',
      tags: ['Education', 'Mentoring', 'Leadership'],
      description: 'Mentored 200+ students in designing and developing 40+ software projects, fostering technical excellence and innovation in the next generation of developers.'
    }
  ];

  return (
    <div className="container">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Featured Projects
      </motion.h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          project.id ? (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link to={`/projects/${project.id}`} className="project-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                <div className="project-image">{project.icon}</div>
                <div className="project-content">
                  <h3>{project.title}</h3>
                  <div className="project-tags">
                    {project.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="tag">{tag}</span>
                    ))}
                  </div>
                  <p>{project.description}</p>
                  <span className="view-case-study">View Case Study →</span>
                </div>
              </Link>
            </motion.div>
          ) : (
            <motion.div
              key={index}
              className="project-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="project-image">{project.icon}</div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <div className="project-tags">
                  {project.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="tag">{tag}</span>
                  ))}
                </div>
                <p>{project.description}</p>
              </div>
            </motion.div>
          )
        ))}
      </div>
    </div>
  );
};

export default Projects